export const gradients = {
  // Hero & CTA gradients
  hero: "bg-gradient-to-br from-primary/10 via-accent/5 to-background",
  heroDark: "dark:from-primary/20 dark:via-accent/10 dark:to-background",
  ctaPrimary: "bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary",
  ctaAccent: "bg-gradient-to-r from-accent to-accent/90 hover:from-accent/90 hover:to-accent",
  
  // Upgrade card gradients
  upgradeCard: "bg-gradient-to-br from-primary/5 via-accent/5 to-primary/10",
  upgradeCardDark: "dark:from-primary/10 dark:via-accent/10 dark:to-primary/20",
  
  // Card gradients
  cardHeader: "bg-gradient-to-r from-background to-muted/20",
  cardBorder: "border-t-2 border-primary/20",
  cardElevated: "bg-gradient-to-br from-card to-muted/5",
  
  // Icon & Badge effects
  iconGlow: "bg-gradient-to-br from-primary/10 to-primary/5 backdrop-blur-sm",
  iconGlowHover: "hover:from-primary/20 hover:to-primary/10",
  badgePrimary: "bg-gradient-to-r from-primary/90 to-primary",
  badgeAccent: "bg-gradient-to-r from-accent/90 to-accent",
  badgeSuccess: "bg-gradient-to-r from-green-500 to-green-600",
  
  // Feature highlights
  featureCard: "bg-gradient-to-br from-background via-muted/20 to-background border-primary/10",
  featureHighlight: "bg-gradient-to-r from-primary/10 to-accent/10",
  
  // Status indicators
  statusNew: "bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20",
  statusInProgress: "bg-gradient-to-r from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20",
  statusCompleted: "bg-gradient-to-r from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20",
  
  // Backgrounds
  pageGradient: "bg-gradient-to-br from-background via-muted/10 to-background",
  sectionGradient: "bg-gradient-to-b from-muted/5 to-background",
};

export const shadows = {
  // Card elevation system (5 levels)
  subtle: "shadow-sm hover:shadow-md transition-all duration-200",
  lifted: "shadow-md hover:shadow-lg transition-all duration-200",
  floating: "shadow-lg hover:shadow-xl transition-all duration-200",
  prominent: "shadow-xl hover:shadow-2xl transition-all duration-200",
  dramatic: "shadow-2xl",
  
  // Specialized shadows
  glow: "shadow-lg shadow-primary/10",
  glowHover: "hover:shadow-xl hover:shadow-primary/20",
  inner: "shadow-inner",
  
  // Colored shadows
  primaryGlow: "shadow-lg shadow-primary/20",
  accentGlow: "shadow-lg shadow-accent/20",
  successGlow: "shadow-lg shadow-green-500/20",
};
